"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_arrow_down_style_1 = __importDefault(require("./uicon.arrow.down.style"));
class UiconArrowDown extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, active, size } = this.props;
            return (jsx_runtime_1.jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: [jsx_runtime_1.jsx("path", { d: "M15.99 23.69a1.49 1.49 0 0 1-1.3-.75L7.56 10.56a1.44 1.44 0 0 1 0-1.5 1.48 1.48 0 0 1 1.3-.75h14.29a1.5 1.5 0 0 1 1.3 2.25L17.3 22.94a1.49 1.49 0 0 1-1.31.75zM8.86 9.81l7.13 12.38.65.37-.65-.37 7.16-12.38H8.86z" }, void 0),
                    jsx_runtime_1.jsx("path", { d: "M15.99 23.69a1.49 1.49 0 0 1-1.3-.75L7.56 10.56a1.44 1.44 0 0 1 0-1.5 1.48 1.48 0 0 1 1.3-.75h14.29a1.5 1.5 0 0 1 1.3 2.25L17.3 22.94a1.49 1.49 0 0 1-1.31.75z", className: classes.fill, hidden: !active }, void 0)] }), void 0));
        };
    }
}
UiconArrowDown.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    active: prop_types_1.default.bool,
    size: prop_types_1.default.number
};
UiconArrowDown.defaultProps = {
    active: false,
    size: null
};
exports.default = react_jss_1.default(uicon_arrow_down_style_1.default)(UiconArrowDown);
//# sourceMappingURL=uicon.arrow.down.js.map